import axios from 'axios'

// 0:ローカルサーバ実行モード(json-server)
// 1:テストサーバ実行モード(Spring)
// 2: 特定リクエストのみテストサーバ実行モード(Spring)
// 7: AWS実行モード(Spring)

//********여기를 바꾼다 S******** 
// let env = '1' // local test
let env = '7' // product
//********여기를 바꾼다 E********

// 特定のリクエストのみテストサーバ(Spring)に向けたいときは以下に追加
let realConnectServerUrls = ['/admin/supplier-brands-delete']

//********여기를 바꾼다 S********
// URL
// let urlForServer = 'http://localhost:5000' // local test
let urlForServer = 'https://ap1s.matchers.jp/' // product
//********여기를 바꾼다 E********

// modify kium 20231126
let urlForAWS = 'https://ap1s.hirosophy.tokyo'
//  'http://hirosophy-backend-env.eba-2umwkzij.ap-northeast-1.elasticbeanstalk.com/'
// 'http://spring-boot.yzuia7jtvy.ap-northeast-1.elasticbeanstalk.com/'
// 'http://springboot-env.gzh59wees3.ap-northeast-1.elasticbeanstalk.com/'

let appJs = ''

export default {
  setAppJs(appJsObj) {
    appJs = appJsObj
  },
  getApiClientForLocal() {
    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
    if (window.localStorage.getItem('accessToken') != null) {
      headers.accessToken = window.localStorage.getItem('accessToken')
    }
    return axios.create({
      baseURL: 'http://localhost:3000',
      withCredentials: false, // This is the default
      headers: headers
    })
  },
  getApiClientForServer() {
    return axios.create({
      baseURL: urlForServer,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        accessToken: window.localStorage.getItem('accessToken')
      }
    })
  },
  getApiClientForAWS() {
    return axios.create({
      baseURL: urlForAWS,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        accessToken: window.localStorage.getItem('accessToken'),
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':
          'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token'
      }
    })
  },
  getServerUrl() {
    if (env === '7') {
      return urlForAWS
    } else {
      return urlForServer
    }
  },
  getApiClientForMultipart() {
    let url
    if (env === '7') {
      url = urlForAWS
    } else {
      url = urlForServer
    }

    return axios.create({
      baseURL: url,
      withCredentials: false, // This is the default
      headers: {
        'content-type': 'multipart/form-data',
        accessToken: window.localStorage.getItem('accessToken')
      }
    })
  },
  loginForUser(request, sendContext) {
    let response = this.sendPost('/sales/login', request, sendContext)
    return response
  },
  loginForAdmin(request, sendContext) {
    let response = this.sendPost('/admin/login', request, sendContext)
    return response
  },
  resourceReservation(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/resource-reservation', request, sendContext)
    return response
  },
  storeDataAnalytics(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/store-data-analytics', request, sendContext)
    return response
  },
  ocrSalesReport(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/ocr-sales-report/login', request, sendContext)
    return response
  },
  menu() {
    let response = this.sendGet('/sales/menu')
    return response
  },
  items() {
    let response = this.sendGet('/admin/items')
    return response
  },  
  orderItems(request) {
    let response = this.sendGet(
      '/sales/orderItems?shippingDate=' + request.shippingDate + '&storeCode=' + request.storeCode
    )
    
    return response
  },
  item(request) {
    let response = this.sendGet('/admin/items/' + request.itemCode)
    return response
  },
  itemsPost(request, sendContext) {    
    let response = this.sendPost('/admin/items/post', request, sendContext)
    return response
  },
  itemsPut(request, sendContext) {
    let response = this.sendPut('/admin/items/put', request, sendContext)
    return response
  },
  itemsDelete(request, sendContext) {
    let response = this.sendPost('/admin/items/delete', request, sendContext)
    return response
  },
  itemsUpdateStock(formData, sendContext) {
    let response = this.sendPost(
      '/admin/items/updateStock',
      formData,
      sendContext
    )
    return response
  },
  makers() {
    let response = this.sendGet('/admin/makers')
    return response
  },
  makersById(request) {
    let response = this.sendGet('/admin/maker/' + request.makerId)
    return response
  },
  makersPost(request, sendContext) {
    let response = this.sendPost('/admin/maker-post', request, sendContext)
    return response
  },
  makersPut(request, sendContext) {
    let response = this.sendPut('/admin/maker-put', request, sendContext)
    return response
  },
  orderMailTargetStore() {
    let response = this.sendGet('/admin/order-mail-target-stores')
    return response
  },
  orderMailTargetStoreByStoreCode(request) {
    console.log("storeCode: ", request.storeCode);
    
    return this.sendGet(
      '/admin/order-mail-target-store/' +
      encodeURIComponent(request.storeCode)
    )
  },
  orderMailTargetStoreUpdate(request, sendContext) {
    return this.sendPost(
    '/admin/order-mail-target-store-update',
    request,
    sendContext
  )
  },
  orderMailTargetStoreRegister(request, sendContext) {
    return this.sendPost(
      '/admin/order-mail-target-store-register',
      request,
      sendContext
    )
  },  

  orderMailReceiver() {
    let response = this.sendGet('/admin/order-mail-receivers')
    return response
  },
  orderMailReceiverByEmail(request) {
    console.log("email: ", request.email);
    
    return this.sendGet(
      '/admin/order-mail-receiver/' +
      encodeURIComponent(request.email)
    )
  },
  orderMailReceiverUpdate(request, sendContext) {
    return this.sendPost(
      '/admin/order-mail-receiver-update',
      request,
      sendContext
    )
  },
  orderMailReceiverRegister(request, sendContext) {
    return this.sendPost(
      '/admin/order-mail-receiver-register',
      request,
      sendContext
    )
  },

  prefecture() {
    let response = this.sendGet('/admin/prefecture')
    return response
  },
  suppliers() {
    let response = this.sendGet('/admin/suppliers')
    return response
  },
  suppliersByStatus() {
    let response = this.sendGet('/admin/suppliers-status-on')
    return response
  },
  supplier(request) {
    let response = this.sendGet('/admin/suppliers/' + request.supplierCode)
    return response
  },
  suppliersPost(request, sendContext) {
    let response = this.sendPost('/admin/suppliers-post', request, sendContext)
    return response
  },
  suppliersPut(request, sendContext) {
    let response = this.sendPut('/admin/suppliers-put', request, sendContext)
    return response
  },
  stores() {
    let response = this.sendGet('/admin/stores')
    return response
  },
  partnerExcelMapping() {
    let response = this.sendGet('/admin/partner-excel-mapping')
    return response
  },
  nonDeletedStores() {
    let response = this.sendGet('/admin/non-deleted-stores')
    return response
  },
  storesWithItems(request) {
    let sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/stores-with-items', request, sendContext)
    return response
  },
  store(request) {
    let response = this.sendGet('/admin/stores/' + request.storeCode)
    return response
  },
  displayStores(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/display-stores', request, sendContext)
    return response
  },
  nonDisplayStoreItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/non-display-store-items', request, sendContext)
    return response
  },
  nonDisplayStoreItems2(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/non-display-store-items2', request, sendContext)
    return response
  },
  nonDisplayStoreItems3(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/non-display-store-items3', request, sendContext)
    return response
  },
  displayStoreItems() {
    let response = this.sendGet('/admin/display-store-items')
    return response
  },
  displayStoreItems2() {
    let response = this.sendGet('/admin/display-store-items2')
    return response
  },
  displayStoreItemsUpdate(request, sendContext) {
    let response = this.sendPost(
      '/admin/display-store-items-update',
      request,
      sendContext
    )
    return response
  },
  displayStoreItemsUpdate2(request, sendContext) {
    let response = this.sendPost(
      '/admin/display-store-items-update2',
      request,
      sendContext
    )
    return response
  },
  displayStoreItemsDelete2(request, sendContext) {
    let response = this.sendPost(
      '/admin/display-store-items-delete2',
      request,
      sendContext
    )
    return response
  },
  storeOfBranch(request) {
    let response = this.sendGet('/admin/branch-stores/' + request.brandId)
    return response
  },
  getAliveStores() {
    let response = this.sendGet('/admin/getAliveStores')
    return response
  },
  storesPost(formData, sendContext) {
    let response = this.sendPost('/admin/stores-post', formData, sendContext)
    return response 
  },
  storeDelete(request, sendContext) {    
    let response = this.sendPost('/admin/store-delete', request, sendContext)
    return response
  },
  storesPut(formData, sendContext) {
    let response = this.sendPost('/admin/stores-put', formData, sendContext)
    return response
  },
  storesItems(request) {
    let response = this.sendGet('/admin/stores-items/' + request.storeCode)
    return response
  },
  storesItemsGroup1(request) {
    let response = this.sendGet('/admin/stores-items-group1/' + request.storeCode)
    return response
  },
  storesItemsGroup2(request) {
    let response = this.sendGet('/admin/stores-items-group2/' + request.storeCode)
    return response
  },
  storesItemsGroup3(request) {
    let response = this.sendGet('/admin/stores-items-group3/' + request.storeCode)
    return response
  },
  copyStoresItems(request) {
    let response = this.sendGet('/admin/stores-items-copy/' + request.storeCode)
    return response
  },
  copyStoresItemsGroup1(request) {
    let response = this.sendGet('/admin/stores-items-copy-group1/' + request.storeCode)
    return response
  },
  copyStoresItemsGroup2(request) {
    let response = this.sendGet('/admin/stores-items-copy-group2/' + request.storeCode)
    return response
  },
  copyStoresItemsGroup3(request) {
    let response = this.sendGet('/admin/stores-items-copy-group3/' + request.storeCode)
    return response
  },
  storesItemsUpdate(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-update',
      request,
      sendContext
    )
    return response
  },
  storesItemsUpdateGroup1(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-update1',
      request,
      sendContext
    )
    return response
  },
  storesItemsUpdateGroup2(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-update2',
      request,
      sendContext
    )
    return response
  },
  storesItemsUpdateGroup3(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-update3',
      request,
      sendContext
    )
    return response
  },
  storesItemsMultiUpdate(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-multi-update',
      request,
      sendContext
    )
    return response
  },
  storesItemsMultiDelete(request, sendContext) {
    let response = this.sendPost(
      '/admin/stores-items-multi-delete',
      request,
      sendContext
    )
    return response
  },  
  itemCategories() {
    let response = this.sendGet('/admin/itemCategories')
    return response
  },
  itemCategoriesByStatus() {
    let response = this.sendGet('/admin/itemCategories-status-on')
    return response
  },
  itemCategoriesByStatusGroup1() {
    let response = this.sendGet('/admin/itemCategories-status-on-group1')
    return response
  },
  itemCategoriesByStatusGroup2() {
    let response = this.sendGet('/admin/itemCategories-status-on-group2')
    return response
  },
  itemCategoriesByStatusGroup3() {
    let response = this.sendGet('/admin/itemCategories-status-on-group3')
    return response
  },
  itemCategoriesPost(request, sendContext) {
    let response = this.sendPost(
      '/admin/itemCategories/post',
      request,
      sendContext
    )
    return response
  },
  itemCategoriesPut(formData) {
    let response = this.sendPut('/admin/itemCategories/put', formData)
    return response
  },
  itemsByCategory(request) {
    let response = this.sendGet(
      '/sales/itemCategories/' + request.itemCategoryId + '/items'
    )
    return response
  },
  sendOrder(request, sendContext) {
    let response = this.sendPost('/sales/send-order', request, sendContext)
    return response
  },
  sendOrderImage(formData, sendContext) {
    let response = this.sendMultipart(
      '/sales/order/uploadImg',
      formData,
      sendContext
    )
    return response
  },
  existOrderByUser(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/existsOrders', request, sendContext)
    return response
  },
  getShippingStatus(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/shippingStatus', request, sendContext)
    return response
  },
  sendUsersFile(formData, sendContext) {
    let response = this.sendMultipart(
      '/admin/users-upload-file',
      formData,
      sendContext
    )
    return response
  },
  tempStores() {
    let response = this.sendGet('/admin/tempStores')
    return response
  },
  sendStoresTempFile(formData, sendContext) {
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }
    
    let response = this.sendMultipart(
      '/admin/stores-temp-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendStoreStocktakingSaveFile(formData, sendContext) {
    let response = this.sendMultipart(
      '/admin/store-stocktaking-save-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendWarehouseStockFile(formData, sendContext) {
    let response = this.sendMultipart(
      '/admin/warehouse-stock-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendWarehouseRealtimeStockFile(formData, sendContext) {
    let response = this.sendMultipart(
      '/admin/warehouse-realtime-stock-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendInvoiceNumberFile(formData, sendContext) {
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }
    
    let response = this.sendMultipart(
      '/admin/invoice-number-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendWarehouseReceivingFile(formData, sendContext) {
    sendContext = {nonDispDialog: true}
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }
    
    let response = this.sendMultipart(
      '/admin/warehouse-receiving-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendWarehouseDeliverFile(formData, sendContext) {
    sendContext = {nonDispDialog: true}
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }
    
    let response = this.sendMultipart(
      '/admin/warehouse-deliver-upload-file',
      formData,
      sendContext
    )
    return response
  },
  tempItems() {
    let response = this.sendGet('/admin/tempItems')
    return response
  },
  sendItemsTempFile(formData, sendContext) {
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }

    let response = this.sendMultipart(
      '/admin/items-temp-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendItemsFile(formData, sendContext) {
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }

    let response = this.sendMultipart(
      '/admin/items-upload-file',
      formData,
      sendContext
    )
    return response
  },
  sendOrdersFile(formData, sendContext) {
    for (let key of formData.keys()) {
      console.log(key, ":", formData.get(key));
    }

    let response = this.sendMultipart(
      '/admin/agency-orders-upload-file',
      formData,
      sendContext
    )
    return response
  },
  existsOrdersByShippingDate(request, sendContext) {
    let response = this.sendGet(
      '/admin/existsOrders/' + request.shippingDate,
      sendContext
    )
    return response
  },
  existsUnlockedOrdersByShippingDate(request, sendContext) {
    let response = this.sendGet(
      '/admin/existsUnlockedOrders/' + request.shippingDate,
      sendContext
    )
    return response
  },
  getOrderStatus(request, sendContext) {
    let response = this.sendGet(
      '/admin/order-lock-status/' + request.shippingDate,
      sendContext
    )
    return response
  },
  orderLock(request, sendContext) {
    let response = this.sendGet(
      '/admin/order-lock/' + request.shippingDate,
      sendContext
    )
    return response
  },
  orderUnlock(request, sendContext) {
    let response = this.sendGet(
      '/admin/order-unlock/' + request.shippingDate,
      sendContext
    )
    return response
  },
  ordersByDay(request, sendContext) {
    let response = this.sendGet(
      '/admin/orders-by-day/' + request.shippingDate,
      sendContext
    )
    return response
  },
  orderDetailsByDay(request, sendContext) {
    let response = this.sendGet(
      '/admin/order-details-by-day/' + request.orderManagementId,
      sendContext
    )
    return response
  },
  orderLockRegion1(request, sendContext) {
    let response = this.sendPost(
      '/admin/order-lock-region1',
      request,
      sendContext
    )
    return response
  },
  orderLockRegion2(request, sendContext) {
    let response = this.sendPost(
      '/admin/order-lock-region2',
      request,
      sendContext
    )
    return response
  },
  fixOrder(request, sendContext) {
    let response = this.sendPost('/admin/fix-order', request, sendContext)
    return response
  },
  clearOrderDetail(request, sendContext) {
    let response = this.sendPost(
      '/admin/order-detail-delete',
      request,
      sendContext
    )
    return response
  },
  orderRegistSlipNumber(request) {
    let response = this.sendPost('/admin/order-regist-slip-number', request)
    return response
  },
  changeShippingDate(request) {
    let response = this.sendPost('/admin/order-update-shipping-date', request)
    return response
  },
  deleteOrder(request, sendContext) {
    let response = this.sendGet(
      '/admin/delete-order/' + request.orderManagementId,
      sendContext
    )
    return response
  },
  downloadConfirm(request) {
    let sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/order-confirm_output_history', request, sendContext )
    return response
  },
  users() {
    let response = this.sendGet('/admin/users')
    return response
  },
  user(request) {
    let sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/user', request, sendContext)
    return response
  },
  updateReferenceStock(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/sales/updateReferenceStock',
      request,
      sendContext
    )
    return response
  },
  usersAuthPut(request, sendContext) {
    let response = this.sendPut('/admin/users-auth/put', request, sendContext)
    return response
  },
  usersInitializePassword(request, sendContext) {
    let response = this.sendPut(
      '/admin/users-initialize-password',
      request,
      sendContext
    )
    return response
  },
  usersPasswordChange(request, sendContext) {
    let response = this.sendPut(
      '/admin/users-password-change',
      request,
      sendContext
    )
    return response
  },
  userPost(request, sendContext) {
    let response = this.sendPost('/admin/user/post', request, sendContext)
    return response
  },
  userUpdate(request, sendContext) {
    console.log("request: ", request);
    
    let response = this.sendPost('/admin/user/update', request, sendContext)
    return response
  },
  userDelete(request, sendContext) {
    let response = this.sendPost('/admin/user/delete', request, sendContext)
    return response
  },
  deliveryslip(request) {
    let response = this.sendGet(
      '/admin/print-delivery-slip/' + request.orderManagementId
    )
    return response
  },
  brands() {
    let response = this.sendGet('/admin/brands')
    return response
  },
  brandsPost(request, sendContext) {
    let response = this.sendPost('/admin/brands-post', request, sendContext)
    return response
  },
  brandsStatusPut(request, sendContext) {
    let response = this.sendPut(
      '/admin/brands-status-put',
      request,
      sendContext
    )
    return response
  },
  brandsBySupplierCode(request) {
    let response = this.sendGet(
      '/admin/brands-by-supplier/' + request.supplierCode
    )
    return response
  },
  businessContacts() {
    let response = this.sendGet('/admin/businessContacts')
    return response
  },
  businessContactsPost(request, sendContext) {
    let response = this.sendPost(
      '/admin/businessContacts-post',
      request,
      sendContext
    )
    return response
  },
  businessContactsDelete(request, sendContext) {
    let response = this.sendPost(
      '/admin/businessContacts-delete',
      request,
      sendContext
    )
    return response
  },
  businessContactsImportantPut(request, sendContext) {
    let response = this.sendPost(
      '/admin/businessContacts-important-put',
      request,
      sendContext
    )
    return response
  },
  supplierBrandPost(request, sendContext) {
    let response = this.sendPost(
      '/admin/supplier-brand-post',
      request,
      sendContext
    )
    return response
  },
  supplierBrands(request, sendContext) {
    let response = this.sendGet('/admin/supplier-brands', request, sendContext)
    return response
  },
  supplierBrandsDelete(request, sendContext) {
    let response = this.sendPost(
      '/admin/supplier-brands-delete',
      request,
      sendContext
    )
    return response
  },

  // Add phase2
  salesReportItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/reportItems', request, sendContext)
    return response
  },
  salesReportItemsReg(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/reportItemsReg', request, sendContext)
    return response
  },
  registSalesReportByUser(request, sendContext) {
    let response = this.sendPost('/sales/sendReport', request, sendContext)
    return response
  },
  stocktakingItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/sales/stocktakingItems',
      request,
      sendContext
    )
    return response
  },
  saveStocktakingItemsByUser(request, sendContext) {
    let response = this.sendPost(
      '/sales/saveStocktakingItems',
      request,
      sendContext
    )
    return response
  },
  stocktakingConfirmItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/sales/stocktakingConfirmItems',
      request,
      sendContext
    )
    return response
  },
  confirmStocktaking(request, sendContext) {
    let response = this.sendPost(
      '/sales/stocktaking-confirm',
      request,
      sendContext
    )
    return response
  },
  registStocktakingDate(request, sendContext) {
    let response = this.sendPost(
      '/admin/registStocktakingDate',
      request,
      sendContext
    )
    return response
  },
  deleteStocktakingDate(request, sendContext) {
    let response = this.sendPost(
      '/admin/deleteStocktakingDate',
      request,
      sendContext
    )
    return response
  },
  getStocktakingDate(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getStocktakingDate',
      request,
      sendContext
    )
    return response
  },
  getStoreStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getStoreStocktaking',
      request,
      sendContext
    )
    return response
  },
  deleteStoreStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/deleteStoreStocktaking',
      request,
      sendContext
    )
    return response
  },
  getStocktakingDetail(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getStocktakingDetail',
      request,
      sendContext
    )
    return response
  },
  updateStocktakingDetail(request, sendContext) {
    let response = this.sendPost(
      '/admin/updateStocktakingDetail',
      request,
      sendContext
    )
    return response
  },
  getStocktakingItemsByAdmin(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getStocktakingItemsByAdmin',
      request,
      sendContext
    )
    return response
  },
  registStocktakingByAdmin(request, sendContext) {
    let response = this.sendPost(
      '/admin/registStocktakingByAdmin',
      request,
      sendContext
    )
    return response
  },
  sendStoreStockFile(formData, sendContext) {
    let response = this.sendMultipart(
      '/admin/store-stock-upload-file',
      formData,
      sendContext
    )
    return response
  },  
  updateStockQuantity(request, sendContext) {
    //sendContext = { nonDispDialog: true }
    let response = this.sendPost(
      '/admin/updateWarehouseRealtimeStocktaking', 
      request, 
      sendContext
    )
    return response
  },
  getStockLock(request, sendContext) {
    sendContext = { nonDispDialog: true }
    let response = this.sendPost(
      '/admin/getStockLock', 
      request, 
      sendContext
    )
    return response
  },
  getWarehouse(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/getWarehouse', request, sendContext)
    return response
  },
  addWarehouse(request, sendContext) {
    let response = this.sendPost('/admin/addWarehouse', request, sendContext)
    return response
  },
  updateWarehouse(request, sendContext) {
    let response = this.sendPost('/admin/updateWarehouse', request, sendContext)
    return response
  },
  warehouseInfo(request, sendContext) {
    let response = this.sendGet('/admin/warehouseInfo', request, sendContext)
    return response
  },
  warehouseItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/warehouseItems', request, sendContext)
    return response
  },
  getWarehouseRealtimeStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/getWarehouseRealtimeStocktaking', request, sendContext)
    return response
  },
  getStandardStock(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/getStoreStandardStock', request, sendContext)
    return response
  },
  getStoreCompareStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/getStoreCompareStocktaking', request, sendContext)
    return response
  },
  updateStandardStock(request, sendContext) {
    // sendContext = { nonDispDialog: true }
    let response = this.sendPost(
      '/admin/updateStoreStandardStock', 
      request, 
      sendContext
    )
    return response
  },
  getStoreStockQuantity(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/getStoreStockQuantity', request, sendContext)
    return response
  },
  updateStoreStockQuantity(request, sendContext) {
    let response = this.sendPost(
      '/sales/updateStoreStockQuantity', 
      request, 
      sendContext
    )
    return response
  },
  saveStockByUser(request, sendContext) {
    let response = this.sendPost('/admin/saveStockByUser', request, sendContext)
    return response
  },
  updateStockByUser(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/updateStockByUser',
      request,
      sendContext
    )
    return response
  },
  warehouseStocktakingConfirmItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/warehouseConfirmItems',
      request,
      sendContext
    )
    return response
  },
  warehouseConfirmStocktaking(request, sendContext) {
    let response = this.sendPost(
      '/admin/warehouseStocktakingConfirm',
      request,
      sendContext
    )
    return response
  },
  getWarehouseStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getWarehouseStocktaking',
      request,
      sendContext
    )
    return response
  },
  deleteWarehouseStocktaking(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/deleteWarehouseStocktaking',
      request,
      sendContext
    )
    return response
  },
  confirmWarehouseStocktaking(request, sendContext) {
    let response = this.sendPost(
      '/admin/confirmWarehouseStocktaking',
      request,
      sendContext
    )
    return response
  },
  getWarehouseStocktakingDetail(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getWarehouseStocktakingDetail',
      request,
      sendContext
    )
    return response
  },
  getArrivalData(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/sales/arrivalData', request, sendContext)
    return response
  },
  uploadIncentiveFile(formData, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendMultipart(
      '/admin/incentive-upload-file',
      formData,
      sendContext
    )
    return response
  },
  storeMapping(formData, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendGet('/admin/store-mapping')
    return response
  },
  uploadSalesExcel(formData, sendContext) {    
    sendContext = {nonDispDialog: true}
    
    let response = this.sendMultipart(
      '/admin/sales/excel-upload',
      formData,
      sendContext
    )
    return response
  },  
  confirmSalesExcel(formData, sendContext) {
    sendContext = { nonDispDialog: true }

    let response = this.sendMultipart(
      '/admin/sales/excel-confirm',
      formData,
      sendContext
    )
    return response
  },
  getSalesReport(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getSalesReportConfirm',
      request,
      sendContext
    )
    return response
  },
  getSalesReportDetail(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/getSalesReportDetail',
      request,
      sendContext
    )
    return response
  },
  updateSalesReport(request, sendContext) {
    let response = this.sendPost(
      '/admin/updateSalesReportDetail',
      request,
      sendContext
    )
    return response
  },
  updateArrival(request, sendContext) {
    let response = this.sendPost('/sales/updateArrival', request, sendContext)
    return response
  },
  existSalesReportByUser(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/sales/existSalesReports',
      request,
      sendContext
    )
    return response
  },
  existSalesReportByAdmin(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/existSalesReports',
      request,
      sendContext
    )
    return response
  },
  deleteSalesReport(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/deleteSalesReport',
      request,
      sendContext
    )
    return response
  },
  getStoreItems(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost('/admin/getStoreItems', request, sendContext)
    return response
  },
  registSalesReportByAdmin(request, sendContext) {
    let response = this.sendPost('/sales/sendReport', request, sendContext)
    return response
  },
  updateReferenceStock(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/sales/updateReferenceStock',
      request,
      sendContext
    )
    return response
  },
  updateSalesReportForIncentive(request, sendContext) {
    sendContext = {nonDispDialog: true}
    let response = this.sendPost(
      '/admin/updateSalesReportForIncentive',
      request,
      sendContext
    )
    return response
  },

  getAxios(url) {
    if (env === '7') {
      console.log('AWSへ電文を投げます')
      return this.getApiClientForAWS()
    } else if (env === '0') {
      console.log('json-serverへ電文を投げます')
      return this.getApiClientForLocal()
    } else if (env === '1') {
      console.log('実際のサーバへ電文を投げます')
      return this.getApiClientForServer()
    } else if (env === '2') {
      if (realConnectServerUrls.indexOf(url) >= 0) {
        console.log('実際のサーバへ電文を投げます')
        return this.getApiClientForServer()
      } else {
        console.log('json-serverへ電文を投げます')
        return this.getApiClientForLocal()
      }
    } else {
      console.log('envが不正')
    }
  },
  sendGet(url, sendContext, isDownload) {
    console.log('send GET request. url: ' + url)
    let response = this.getAxios(url).get(url, hasDialogComponent)

    let hasDialogComponent
    let forwardNameOnClose
    if (sendContext != null) {
      hasDialogComponent = sendContext.hasDialogComponent
      forwardNameOnClose = sendContext.forwardNameOnClose
    }

    response
      .then(response => {
        console.log('HTTP Status: ' + response.status)
        // console.log('response body: ' + JSON.stringify(response.data))
        if (isDownload) {
          this.downloadFile(response, 'customFilename')
          return
        }
        if (hasDialogComponent != null) {
          let result = response.data.result
          let errors = response.data.errors
          if (result == '1') {
            hasDialogComponent.showResultDialog(
              errors[0].errorDescription,
              null,
              true
            )
          } else {
            hasDialogComponent.showResultDialog(
              'データ送信が完了しました',
              forwardNameOnClose,
              false
            )
          }
        }
      })
      .catch(error => {
        console.log('HTTP Status: ' + response.status)
        console.log('response body: ' + JSON.stringify(response.data))
        console.log('There was an error:', error.response)
        if (error.response.status === 401) {
          console.log('session expired')
          let forward = 'sales/new-user-login'
          if (appJs.$store.state.isAdminOperation) {
            forward = 'admin/new-admin-login'
          }
          appJs.showResultDialog(
            'セッションが切れました。ログイン画面から操作をやり直してください',
            forward,
            true
          )
        } else {
          appJs.showResultDialog('データ送信が失敗しました', null, true)
        }
      })

    return response
  },
  sendPut(url, formData, sendContext) {    
    return this.sendPost(url, formData, sendContext)
  },
  sendPost(url, requestBody, sendContext) {
    // console.log('send POST request. url: ' + url)
    // console.log('request body: ' + JSON.stringify(requestBody))

    let forwardNameOnClose
    let callbackAfterOnClose
    let dialogMessage
    let nonDispDialog
    if (sendContext != null) {
      dialogMessage = sendContext.dialogMessage
      forwardNameOnClose = sendContext.forwardNameOnClose
      callbackAfterOnClose = sendContext.callbackAfterOnClose
      nonDispDialog = sendContext.nonDispDialog
    }

    let response

    if (env === '0') {
      response = this.getAxios(url).get(url, requestBody)
    } else if (env === '1' || env === '7') {
      response = this.getAxios(url).post(url, requestBody)
    } else if (env === '2') {
      if (realConnectServerUrls.indexOf(url) >= 0) {
        response = this.getAxios(url).post(url, requestBody)
      } else {
        response = this.getAxios(url).get(url, requestBody)
      }
    } else {
      console.log('envが不正！')
    }

    response.then(response => {
        console.log('HTTP Status: ' + response.status)
        // console.log('response body: ' + JSON.stringify(response.data))
        let result = response.data.result
        let errors = response.data.errors
        // result=1の場合は、サーバから返却されたエラー内容を表示
        if (result == '1') {
          appJs.showResultDialog(errors[0].errorDescription, null, true)
          // let e = new Error('処理結果=1が返却されました')
          // e.result = 1
          // throw e
        } else {
          // 正常時、ダイアログが設定されている場合は、その内容を表示
          if (!nonDispDialog) {
            appJs.showResultDialog(
              dialogMessage != null
                ? dialogMessage
                : 'データ送信が完了しました',
              forwardNameOnClose,
              false,
              callbackAfterOnClose,
              response
            )
          }
        }
      }).catch(error => {
        console.log('HTTP Status: ' + error.response.status)
        console.log('response body: ' + JSON.stringify(error.response.data))
        console.log('There was an error:', error.response)

        if (error.response) {
          console.error("Server responded:", error.response.status, error.response.data);
        } else if (error.request) {
          console.error("No response, request was:", error.request);
        } else {
          console.error("Axios config error:", error.message);
        }


        if (error.response.status === 401) {
          console.log('session expired')
          let forward = 'sales/new-user-login'
          if (appJs.$store.state.isAdminOperation) {
            forward = 'admin/new-admin-login'
          }
          appJs.showResultDialog(
            'セッションが切れました。ログイン画面から操作をやり直してください',
            forward,
            true
          )
        } else {
          if (!nonDispDialog) {
            appJs.showResultDialog('データ送信が失敗しました', null, true)
          }
        }
      })

    return response
  },
  sendMultipart(url, formData, sendContext) {
    console.log('send ' + url)

    let forwardNameOnClose
    let callbackAfterOnClose
    let dialogMessage
    let nonDispDialog
    if (sendContext != null) {
      dialogMessage = sendContext.dialogMessage
      forwardNameOnClose = sendContext.forwardNameOnClose
      callbackAfterOnClose = sendContext.callbackAfterOnClose
      nonDispDialog = sendContext.nonDispDialog
    }

    let config = {
      'content-type': 'multipart/form-data'
      //      accept: '*/*'
    }

    let response = this.getApiClientForMultipart().post(url, formData, config)
    // let response = axios.post(`http://localhost:9090` + url, formData, config)

    response
      .then(response => {
        console.log('HTTP Status: ' + response.status)
        // console.log('response body: ' + JSON.stringify(response.data))
        let result = response.data.result
        let errors = response.data.errors
        if (result == '1') {
          appJs.showResultDialog(errors[0].errorDescription, null, true)
        } else {
          // 正常時、ダイアログが設定されている場合は、その内容を表示
          if (!nonDispDialog) {
            appJs.showResultDialog(
              dialogMessage != null
                ? dialogMessage
                : 'データ送信が完了しました',
              forwardNameOnClose,
              false,
              callbackAfterOnClose,
              response
            )
          }
        }
      })
      .catch(error => {
        console.log('HTTP Status: ' + response.status)
        console.log('response body: ' + JSON.stringify(response.data))
        console.log('There was an error:', error)
        appJs.showResultDialog(
          'ファイル送信中にエラーが発生しました',
          null,
          true
        )
      })

    return response
  },
  downloadFile(response, filename) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([response.body], {
      type: 'application/pdf'
    })

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
      return
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob)
    var link = document.createElement('a')
    link.href = data
    link.download = filename + '.pdf'
    link.click()
    setTimeout(function() {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data)
    }, 100)
  }
}
